import { SkeletonBox, SkeletonContainer } from "@/components/ui/skeleton";

export function NotificationListPending() {
  return (
    <SkeletonContainer className="items-start gap-3 rounded-md border border-border bg-surface-primary px-3 py-2.5 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] dark:bg-surface-inset">
      <SkeletonBox className="size-8 shrink-0 rounded-md" />
      <div className="flex min-w-0 flex-1 flex-col gap-2 pr-8">
        <SkeletonBox className="h-3.5 w-4/5" />
        <SkeletonBox tone="muted" className="h-3 w-3/5" />
        <SkeletonBox tone="muted" className="h-2.5 w-16" />
      </div>
    </SkeletonContainer>
  );
}
